import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rnpl-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  @Input()
  cardTitle: string;

  constructor() { }

  ngOnInit() {
  }

}
